(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('SupplierCouponSearch', SupplierCouponSearch);

    SupplierCouponSearch.$inject = ['$resource'];

    function SupplierCouponSearch($resource) {
        var resourceUrl = 'api/_search/supplier-coupon/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
